import { animate, state, style, transition, trigger } from '@angular/animations';
import { DatePipe, formatDate } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    Inject,
    Injector,
    Input,
    OnInit,
    OnDestroy,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
    MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
    MatLegacyDialog as MatDialog,
    MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ResolveData } from '@angular/router';
import { Permissions } from '@dave/types/dist/proto/global/permissions';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Actions, ofType } from '@ngrx/effects';
import { Dictionary } from '@ngrx/entity';
import { Store } from '@ngrx/store';
import { isArray } from 'chart.js/helpers';
import { subscribe } from 'graphql/execution/index';
import { number } from 'mathjs';
import { Moment } from 'moment';
import * as moment from 'moment/moment';
import {
    BehaviorSubject,
    combineLatest,
    firstValueFrom,
    from,
    Observable,
    of,
    switchMap,
    Subscription,
    merge,
} from 'rxjs';
import {
    distinctUntilChanged,
    filter,
    first,
    map,
    shareReplay,
    skip,
    startWith,
    take,
    takeUntil, tap,
    withLatestFrom,
    debounceTime,
} from 'rxjs/operators';
import {
    getPartnerMainOffice,
    getPartnerOfficesFetched,
} from 'src/app/dave-data-module/State/selectors/partners.selectors';
import {
    ClockInExportType,
    CsvExportDialogComponent,
    CsvExportDialogComponentDialogData,
} from '../../../dave-commission-module/components/csv-export-dialog/csv-export-dialog.component';
import { ClockInTypeEntity, EnumClockInTypeSlug } from '../../../dave-data-module/entities/clock-in-type.entity';
import { ClockInEntity, ClockInTypeNames, ClockInTypes } from '../../../dave-data-module/entities/clock-in.entity';
import { CommissionEntity } from '../../../dave-data-module/entities/commission.entity';
import { CustomerEntity } from '../../../dave-data-module/entities/customer.entity';
import { EmployeeSalaryTypeEntity } from '../../../dave-data-module/entities/employee-salary-type.entity';
import {
    EmployeeToVacationEntity,
    VacationTypeEnumNameMap,
} from '../../../dave-data-module/entities/employee-to-vacation.entity';
import { EmployeeStatusEnum, SalaryTypes } from '../../../dave-data-module/entities/employee.entity';
import { SalaryTypeEntity } from '../../../dave-data-module/entities/salary-type.entity';
import { ClockInTypeResolver } from '../../../dave-data-module/guards/clock-in-type.resolver';
import { CommissionResolver } from '../../../dave-data-module/guards/commission.resolver';
import { CustomerResolver } from '../../../dave-data-module/guards/customer.resolver';
import { EmployeeSalaryTypeResolver } from '../../../dave-data-module/guards/employee-salary-type.resolver';
import { EmployeeToVacationResolver } from '../../../dave-data-module/guards/employee-to-vacation.resolver';
import { EmployeeResolver } from '../../../dave-data-module/guards/employee.resolver';
import { PartnerOfficeResolver } from '../../../dave-data-module/guards/partner-office.resolver';
import { SalaryTypeResolver } from '../../../dave-data-module/guards/salary-type.resolver';
import { StatusFromBackofficeResolver } from '../../../dave-data-module/guards/statusFromBackoffice.resolver';
import { TravelZoneResolver } from '../../../dave-data-module/guards/travel-zone.resolver';
import { UserToCommissionResolver } from '../../../dave-data-module/guards/user-to-commission.resolver';
import { UserResolver } from '../../../dave-data-module/guards/user.resolver';
import { WorkDayResolver } from '../../../dave-data-module/guards/work-day.resolver';
import { WorkedTimesResolver } from '../../../dave-data-module/guards/worked-times.resolver';
import { FrontendDate } from '../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../dave-data-module/helper/helper';
import { ClockInDataService } from '../../../dave-data-module/services/clockin-data.service';
import { State } from '../../../dave-data-module/State';
import { BaseActionTypes } from '../../../dave-data-module/State/actions/base.actions';
import { ClockInActionTypes } from '../../../dave-data-module/State/actions/clock-in.actions';
import { EmployeeSalaryTypeActions } from '../../../dave-data-module/State/actions/employee-salary-type.actions';
import { SalaryTypeActions } from '../../../dave-data-module/State/actions/salary-type.actions';
import { clockInTypesFeatureKey } from '../../../dave-data-module/State/reducers/clock-in-type.reducer';
import { commissionsFeatureKey } from '../../../dave-data-module/State/reducers/commission.reducer';
import { employeesFeatureKey } from '../../../dave-data-module/State/reducers/employees.reducer';
import { employeeToVacationFeatureKey } from '../../../dave-data-module/State/reducers/employeeToVacation.reducer';
import { StatusFromBackofficeFeatureKey } from '../../../dave-data-module/State/reducers/statusFromBackoffice.reducer';
import { usersFeatureKey } from '../../../dave-data-module/State/reducers/users.reducer';
import { workDaysFeatureKey } from '../../../dave-data-module/State/reducers/work-day.reducer';
import { workedTimesFeatureKey } from '../../../dave-data-module/State/reducers/worked-times.reducer';
import {
    getClockInTypeDictionary,
    getClockInTypes,
    getClockInTypesFetched,
} from '../../../dave-data-module/State/selectors/clock-in-type.selectors';
import {
    getCommissionById,
    getCommissionDictionary,
    getCommissions,
    getCommissionsActive,
    getCommissionsFetched,
} from '../../../dave-data-module/State/selectors/commission.selector';
import {
    getEmployeeSalaryTypeById,
    getEmployeeSalaryTypes,
} from '../../../dave-data-module/State/selectors/employee-salary-type.selector';
import {
    getEmployeeById,
    getEmployeeDictionary,
    getEmployees, getEmployeesActive,
    getEmployeesActiveSortedByNameStartWithMe,
} from '../../../dave-data-module/State/selectors/employees.selectors';
import { getPermissions } from '../../../dave-data-module/State/selectors/permissions.selectors';
import {
    getSalaryTypeById,
    getSalaryTypeDictionary,
    getSalaryTypeFetched,
    getSalaryTypesActive,
} from '../../../dave-data-module/State/selectors/salary-type.selector';
import {
    getStatusFromBackofficeFetched,
} from '../../../dave-data-module/State/selectors/statusFromBackoffice.selectors';
import {
    getTravelZoneById,
    getTravelZonesFetched,
} from '../../../dave-data-module/State/selectors/travel-zone.selector';
import {
    getUserToCommissionByCommissionId,
    getUserToCommissionFetched,
} from '../../../dave-data-module/State/selectors/user-to-commission.selector';
import { getUser, getUserDictionary } from '../../../dave-data-module/State/selectors/users.selectors';
import { getWorkDays, getWorkDaysFetched } from '../../../dave-data-module/State/selectors/work-day.selectors';
import {
    getWorkedTimes,
    getWorkedTimesFetched,
} from '../../../dave-data-module/State/selectors/worked-times.selectors';
import {
    AppConfirmationDialogComponent,
    AppConfirmationDialogData,
} from '../../../dave-utils-module/app-dialog-module/app-confirmation-dialog/app-confirmation-dialog.component';
import {
    FILTER_TYPE_SEARCH_MULTI_SELECT,
    FilterOption,
    IFilterTypeSearchMultiSelectValue,
} from '../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
    BreakpointObserverService,
} from '../../../dave-utils-module/dave-shared-components-module/services/breakpoint-observer.service';
import {
    PermissionService,
} from '../../../dave-utils-module/dave-shared-components-module/services/permission.service';
import {
    SelectSearchOption,
} from '../../../dave-utils-module/select-search/components/select-search/select-search.component';
import {
    DetailListDialogReturn,
    DetailListTemplateDialogComponent,
    DetailListTemplateDialogData,
} from '../../../detail-list-template-dialog/components/detail-list-template-dialog.component';
import {
    appMatDialogDefaultConfig,
    isNotNullOrUndefined,
    sameDay,
    sortByDateProperty,
    sortClockIns,
    TableColumnConfig,
    uniqArray,
} from '../../../helper/helper';
import { CommissionMeta, UserAdministrationMeta } from '../../../helper/page-metadata';
import { CustomLabelService } from '../../../services/custom-label/custom-label.service';
import { FilterTypes } from '../../../services/default-filter.service';
import { LoadingService } from '../../../services/loading.service';
import {
    NewClockinPopupComponent,
    NewClockinPopupComponentDialogData,
} from '../new-clockin-popup/new-clockin-popup.component';
import { SALARY_TYPE_FEATURE_KEY } from '../../../dave-data-module/State/reducers/salary-type.reducer';
import { JsonStatsPlugin } from '@angular-devkit/build-angular/src/webpack/plugins';
import { ClockInHelperService } from '../../../services/clock-in-helper.service';
import {
    getEmployeeToVacationDictionary
} from '../../../dave-data-module/State/selectors/employee-to-vacation.selectors';
import { WorkDayEntity } from '../../../dave-data-module/entities/work-day.entity';
import { customersFeatureKey } from '../../../dave-data-module/State/reducers/customers.reducer';
import {CustomerDataService} from '../../../dave-data-module/services/customer-data.service';

interface HourListFilter {
    [FilterTypes.Employees]: IFilterTypeSearchMultiSelectValue<number>[];
    [FilterTypes.Commissions]: IFilterTypeSearchMultiSelectValue<number>[];
}

export interface HourListComponentDialogData {
    EmployeeId?: number;
    CommissionId?: number;
}

interface SelectedTimeSpan {
    Year: number;
    Quarter: number | null;
}

interface ClockInTableData {
    ClockInEntity: ClockInEntity;
    Type: string;
    TimeStamp: string;
    Commission: string;
    Customer: string;
    Note: string;
    DrivingTime?: string;
    CanEdit$: Observable<boolean>;
}

interface WorkDayTableData {
    EveryValid$: BehaviorSubject<boolean>;
    WorkdayIds: number[];
    TableData$: Observable<ClockInTableData[]>;
    DateData: Date;
    Date: string;
    WorkTime: number;
    ProjectTime: number;
    OverTime: number;
    BreakTime: number;
    ForcedBreakTime: number;
    DrivingTime: number;
    SomeExported: boolean;
    EmployeeListData$: Observable<EmployeeListTableData[]>;
    CanDeleteAll: boolean;
    ShowDeleteAll: boolean;
    IsHoliday: boolean;
    CommissionNames: string;
    CustomerNames: string;
    EmployeeToVacations: EmployeeToVacationEntity[];
    SalaryTypes$: Observable<{ salaryType: EmployeeSalaryTypeEntity; commissionLabel$: Observable<string> }[]>;
}

interface EmployeeListTableData {
    IsValid: boolean;
    ClockInTableData: MatTableDataSource<ClockInTableData>;
    DisplayName: string;
    WorkTime: string;
    ProjectTime: string;
    WorkDayId: number;
    DrivingTime: string;
    EmployeeId: number;
    Date: Date;
    OtherClockInsExist?: boolean;
    Identifier: string;
}

interface PanelData {
    TableData: MatTableDataSource<WorkDayTableData>;
    Year: number;
    Sort: string;
    WeekOfYear: number;
    WorkTimeSum: number;
    ProjectTimeSum: number;
    OverTimeSum: number;
    WeekStart?: string;
    WeekEnd?: string;
}

enum YearQuarter {
    Year = 0,
    Quarter = 1,
}

function getTimespanObjectFromTimeSelectString(timeSelectString: string): SelectedTimeSpan {
    if (!timeSelectString.includes('.')) {
        return {
            Year: Number.parseInt(timeSelectString),
            Quarter: null,
        };
    }
    return {
        Year: Number.parseInt(timeSelectString.split('.')[0]),
        Quarter: Number.parseInt(timeSelectString.split('.')[1]),
    };
}

@Component({
    selector: 'app-hour-list-2',
    templateUrl: './hour-list-2.component.html',
    styleUrls: ['./hour-list-2.component.scss'],
    providers: [DatePipe],
    animations: [trigger('detailExpand', [state('collapsed', style({
        height: '0px',
        minHeight: '0',
    })), state('expanded', style({ height: '*' })), transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))])],
})
export class HourList2Component implements OnInit, OnDestroy {
    public YearQuarterYear = YearQuarter.Year;
    public YearQuarterQuarter = YearQuarter.Quarter;
    public yearQuarter = new FormControl<YearQuarter>(YearQuarter.Quarter);

    public timeSelect = new FormControl<string>(moment(new Date()).format('YYYY.Q'));
    public timeSelectOptions$ = new BehaviorSubject<string[]>([this.timeSelect.value]);

    public static readonly DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        maxWidth: '100%',
        width: '95vw',
        height: '90vh',
        maxHeight: 'calc(100vh - 3.5rem)',
    };
    @ViewChild('selectSalaryTypeForm') selectSalaryTypeForm: TemplateRef<any>;
    public static readonly RequiredResolvers: ResolveData = {
        [clockInTypesFeatureKey]: ClockInTypeResolver,
        [workedTimesFeatureKey]: WorkedTimesResolver,
        [employeesFeatureKey]: EmployeeResolver,
        [employeeToVacationFeatureKey]: EmployeeToVacationResolver,
        // [clockInsFeatureKey]: ClockInResolver,
        [workDaysFeatureKey]: WorkDayResolver,
        [commissionsFeatureKey]: CommissionResolver,
        [usersFeatureKey]: UserResolver,
        [StatusFromBackofficeFeatureKey]: StatusFromBackofficeResolver,
        [SALARY_TYPE_FEATURE_KEY]: EmployeeSalaryTypeResolver,
        ['partnerOffice']: PartnerOfficeResolver,
        // [customersFeatureKey]: CustomerResolver,
    };
    public GlobalClockInTypeId = 1;
    public ExpandedPanel: number;
    public ExpandedWorkDay: string | null = null;
    public ExpandedWorkDayFromEmployee: string;
    public ClockInColumns$: Observable<TableColumnConfig<ClockInTableData>[]> = combineLatest([this.cls.getSingle$('Commission'), this.cls.getSingle$('CustomerSupplier')]).pipe(
        map(([commissionLabel, customerLabel]) => [
            { header: 'Art', name: 'Type' },
            { header: 'Uhrzeit', name: 'TimeStamp' },
            { header: commissionLabel, name: 'Commission' },
            { header: customerLabel, name: 'Customer' },
            { header: 'Anmerkung', name: 'Note' },
            { header: 'Fahrzeit', name: 'DrivingTime' },
        ]),
    );
    public WorkDayLoading = false;
    public WorkDayTimeColumns = [
        'WorkTime',
        'ProjectTime',
        'OverTime',
        'BreakTime',
        'ForcedBreakTime',
        'DrivingTime',
    ];
    public WorkDayColumns: TableColumnConfig<WorkDayTableData>[] = [
        { header: 'Datum', name: 'Date' },
        { header: 'Arbeitsstunden', name: 'WorkTime' },
        { header: 'Projektzeit', name: 'ProjectTime' },
        { header: 'Überstunden', name: 'OverTime' },
        { header: 'Gesamtpausenzeit', name: 'BreakTime' },
        { header: 'Automatische Pausenzeit', name: 'ForcedBreakTime' },
        { header: 'Fahrzeit', name: 'DrivingTime' },
    ];
    public EmployeeListColumns: TableColumnConfig<EmployeeListTableData>[] = [
        { header: 'Mitarbeiter', name: 'DisplayName' },
        { header: 'Arbeitsstunden', name: 'WorkTime' },
        { header: 'Projektzeit', name: 'ProjectTime' },
        { header: 'Fahrzeit', name: 'DrivingTime' },
    ];
    private readonly onInit$ = new BehaviorSubject<boolean>(false);
    public ShowCommissions$ = new BehaviorSubject(true);
    public ShowEmployeeSalaryTypesForEmployeeId$ = new BehaviorSubject<number | null>(null);
    public ShowSalaryTypes$ = this.store.select(getPartnerOfficesFetched).pipe(
        filter((f) => f),
        switchMap(() => this.store.select(getPartnerMainOffice).pipe(map((po) => !(po?.AdditionalData?.hideEmployeeSalaryType === true)))),
    );
    public ShowOvertime$ = new BehaviorSubject(false);
    public ShowBreakTime$ = new BehaviorSubject(true);
    public showEmptyWorkDays$ = new BehaviorSubject(true);
    public DisplayedWorkDayColumns$ = combineLatest([this.BP.MobileQuery, this.onInit$, this.ShowOvertime$, this.ShowBreakTime$, this.ShowCommissions$]).pipe(
        map(([mq, , ShowOvertime, ShowBreakTime, showCommissions]) => {
            const ret: Array<keyof WorkDayTableData | 'icon' | 'delete'> = ['Date', 'WorkTime', 'ProjectTime'];
            if (!mq) {
                if (ShowOvertime) {
                    ret.push('OverTime');
                }
                if (ShowBreakTime) {
                    ret.push('BreakTime', 'ForcedBreakTime');
                }
                ret.push('DrivingTime');
            }
            if (showCommissions) {
                ret.push('CommissionNames', 'CustomerNames');
            }
            ret.push('icon', 'delete');
            return ret;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );
    public DisplayedClockInColumns$ = this.BP.MobileQuery.pipe(map((mq) => (mq ? ['line', 'Type', 'TimeStamp', /*'DrivingTime', */ 'button'] : ['line', 'Type', 'TimeStamp', 'Commission', 'Customer', 'Note', /*'DrivingTime', */ 'button'])));
    public DisplayedEmployeeListColumns$ = combineLatest([this.BP.MobileQuery, this.onInit$, this.ShowOvertime$, this.ShowBreakTime$]).pipe(
        map(([mq, , ShowOvertime, ShowBreakTime]) => {
            const ret: Array<keyof EmployeeListTableData | 'spacer' | 'icon'> = ['DisplayName', 'WorkTime', 'ProjectTime', 'DrivingTime'];
            if (ShowOvertime && ShowBreakTime) {
                ret.push('spacer');
            }
            ret.push('icon');
            return ret;
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    public ClockInTypes = ClockInTypes;
    // public Commission: CommissionEntity;
    // public CurrentWorkDay: BehaviorSubject<WorkDayTableData> = new BehaviorSubject(null);
    protected filterSettings$: Observable<FilterOption[]> = combineLatest([this.store.select(getCommissionsActive), this.store.select(getEmployeesActiveSortedByNameStartWithMe), this.cls.getMultiple$('Commission')]).pipe(
        filter((v) => v.every(isNotNullOrUndefined)),
        map(([commissions, employees, commissionLabel]) => {
            let employeeValues: IFilterTypeSearchMultiSelectValue<number>[] = employees.map((c) => ({
                label: c.DisplayName,
                id: c.Id,
            }));
            let commissionValues: IFilterTypeSearchMultiSelectValue<number>[] = commissions.map((c) => ({
                label: c.optionLabel,
                id: c.Id,
            }));

            return [
                {
                    Name: FilterTypes.Commissions,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: commissionLabel,
                    Icon: CommissionMeta.Icon,
                    Values: commissionValues,
                },
                {
                    Name: FilterTypes.Employees,
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Mitarbeiter',
                    Icon: UserAdministrationMeta.Icon,
                    Values: employeeValues,
                },
            ];
        }),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );


    protected filterValues$ = new BehaviorSubject<HourListFilter>({
        [FilterTypes.Commissions]: [],
        [FilterTypes.Employees]: [],
    });
    protected filterAmount$ = this.filterValues$.pipe(
        map((filter) =>
            Object.values(filter).reduce((prev, curr) => {
                if (curr) {
                    if (isArray(curr)) {
                        if (curr.length) {
                            return prev + 1;
                        }
                    } else {
                        return prev + 1;
                    }
                }
                return prev;
            }, 0),
        ),
    );
    protected filteredCommissionIds$ = this.filterValues$.pipe(
        map((filter) => filter[FilterTypes.Commissions]?.map((c) => c.id)),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    );
    protected filteredEmployeeIds$ = this.filterValues$.pipe(
        map((filter) => filter[FilterTypes.Employees]?.map((e) => e.id)),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
    );

    @Input() set ShowCommissions(value: boolean) {
        this.ShowCommissions$.next(value);
    }

    @Input() set ShowOvertime(value: boolean) {
        this.ShowOvertime$.next(value);
    }

    @Input() set ShowBreakTime(value: boolean) {
        this.ShowBreakTime$.next(value);
    }

    @Input() set ShowEmptyWorkDays(value: boolean) {
        this.showEmptyWorkDays$.next(value);
    }

    protected CompareById(a, b) {
        return a.Id === b.Id;
    }

    protected salaryTypeOptions$ = this.store.select(getSalaryTypesActive).pipe(
        map((salaryTypes) =>
            salaryTypes
                .sort(sortByDateProperty('CreatedAt'))
                .reverse()
                .map<SelectSearchOption>((p) => ({
                    Id: p.Id,
                    optionLabel: p.Name,
                })),
        ),
    );

    @Input() showEmployeeHierarchie = true;
    @Input() showFilter = true;

    @Input() ignoreSeePermissions = false;

    protected dataFetched = false; //TODO mmaybe weg
    public mainDataLoaded = false;
    showCommissionCsvExportBtn: number | null;

    public PanelData: PanelData[] = [];

    protected accessibleEmployeeIds$ = this.store.select(getEmployees).pipe(
        map(employees => employees.filter(e => e.PermissionsFromEntityRoles.includes(Permissions.EditClockIn))),
        map(employees => employees.map((e) => e.Id)),
        shareReplay({ refCount: true, bufferSize: 1 }),
    );

    constructor(
        private store: Store<State>,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA)
        Dialogdata: HourListComponentDialogData,
        private datePipe: DatePipe,
        public BP: BreakpointObserverService,
        public PS: PermissionService,
        public LS: LoadingService,
        private actions$: Actions,
        u2cResolver: UserToCommissionResolver,
        private salaryTypeResolver: SalaryTypeResolver,
        private commissionResolver: CommissionResolver,
        private travelZoneResolver: TravelZoneResolver,
        private statusBackofficeResolver: StatusFromBackofficeResolver,
        protected cls: CustomLabelService,
        private injector: Injector,
        protected clockInDataService: ClockInDataService,
        protected clockInHelperService: ClockInHelperService,
        protected cd: ChangeDetectorRef,
        protected customerDataService: CustomerDataService
    ) {
        firstValueFrom(this.store.select(getUserToCommissionFetched)).then((f) => {
            if (!f) {
                u2cResolver.resolve();
            }
        });
        firstValueFrom(combineLatest(Object.values(HourList2Component.RequiredResolvers).map((resolver) => this.injector.get(resolver).resolve())).pipe(filter((res) => res.every((f) => f)))).then(() => (this.dataFetched = true));
        if (Dialogdata) {
            this.showCommissionCsvExportBtn = Dialogdata.CommissionId || null;
            this.ShowCommissions$.next(!Dialogdata.CommissionId);
            this.showEmptyWorkDays$.next(!Dialogdata.CommissionId);
            this.showEmployeeHierarchie = !Dialogdata.EmployeeId;
            this.ignoreSeePermissions = !!Dialogdata.CommissionId;
            if (Dialogdata.EmployeeId || Dialogdata.CommissionId) {
                this.showFilter = false;
                this.filterValues$.next({
                    ...this.filterValues$.value,
                    [FilterTypes.Commissions]: Dialogdata.CommissionId ? [{
                        id: Dialogdata.CommissionId,
                        label: 'todo',
                    }] : this.filterValues$.value[FilterTypes.Commissions],
                    [FilterTypes.Employees]: Dialogdata.EmployeeId ? [{
                        id: Dialogdata.EmployeeId,
                        label: 'todo',
                    }] : this.filterValues$.value[FilterTypes.Employees],
                });
            }
            this.ShowEmployeeSalaryTypesForEmployeeId$.next(Dialogdata.EmployeeId || null);
            if (!Dialogdata.EmployeeId) {
                this.ShowOvertime$.next(!Dialogdata.CommissionId);
                this.ShowBreakTime$.next(!Dialogdata.CommissionId);
            } else {
                firstValueFrom(this.store.select(getEmployeeById({ id: Dialogdata.EmployeeId }))).then((e) => this.ShowOvertime$.next(e.SalaryType != SalaryTypes.PerHour && !Dialogdata.CommissionId));
            }
            const pollActions$ = actions$.pipe(
                ofType(ClockInActionTypes.UpdateAll, ClockInActionTypes.UpdateMany, ClockInActionTypes.AddClockInsSuccess, ClockInActionTypes.ModifyClockInsSuccess, ClockInActionTypes.DeleteClockInsSuccess),
                // tap(a => console.log(a.type)),
                debounceTime(100),
            );
            this.subscriptions.push(
                merge(this.filterValues$.pipe(distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)), skip(1)), pollActions$).subscribe(() => {
                    // console.log('reload');

                    this.doReload(getTimespanObjectFromTimeSelectString(this.timeSelect.value), this.filterValues$.value);
                }),
            );
        }
        // if (!this.ignoreSeePermissions) {
        //     this.store.select(getUser).pipe(
        //         withLatestFrom(this.store.select(getEmployees)),
        //         map(([user, employees]) => {
        //             return employees.find((e) => e.UserId === user.Id);
        //         }),
        //         filter(isNotNullOrUndefined),
        //         take(1)
        //     ).subscribe(employee => {
        //         console.log('a', employee.PermissionsFromEntityRoles.includes(Permissions.EditClockIn))
        //     })
        // }
        // console.log("ignoreSeePermissions", this.ignoreSeePermissions)
        //
    }

    EmployeeSalaryTypeLabel = EmployeeSalaryTypeEntity.EntityName;
    EmployeeSalaryTypeIcon: IconProp = 'comments-dollar';
    public trackByWeek = (index: number, item: PanelData) => item.WeekOfYear;
    public trackByName = (index: number, item: { name: string }) => item.name;

    // @ts-ignore
    public FilterCustomColumns = (c: TableColumnConfig<ClockInTableData | WorkDayTableData>) => c.name !== 'Note' && c.name !== 'CommissionNames';

    private sameDay(d1, d2) {
        return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
    }

    public fromDataDate$ = new BehaviorSubject<string>('');
    public toDataDate$ = new BehaviorSubject<string>('');

    protected isFirstTimeSelectOption$ = combineLatest([
        this.timeSelectOptions$,
        this.timeSelect.valueChanges.pipe(startWith(null)),
    ]).pipe(
        map(([options]) => options[options.length - 1] === this.timeSelect.value),
        distinctUntilChanged(),
    );
    protected isLastTimeSelectOption$ = combineLatest([
        this.timeSelectOptions$,
        this.timeSelect.valueChanges.pipe(
            startWith(null),
        ),
    ]).pipe(
        map(([options]) => options[0] === this.timeSelect.value),
        distinctUntilChanged(),
    );

    protected loadedEmployeeListData$ = new BehaviorSubject(new Map<string, EmployeeListTableData[]>());
    protected loadedDayData$ = new BehaviorSubject(new Map<string, ClockInTableData[]>());


    public toggleDay(date: string, reload: boolean) {
        if (date === this.ExpandedWorkDay && !reload) {
            this.ExpandedWorkDay = null;
        } else {
            // console.log('asd');
            this.ExpandedWorkDay = date;
            this.WorkDayLoading = true;
            this.cd.detectChanges();
            if (this.showEmployeeHierarchie) {
                this.loadedEmployeeListData$.pipe(take(1)).subscribe(loaded => {
                    if (!loaded.has(date)) {
                        this.loadEmployeeList(moment(date, 'DD.MM.YYYY').toDate()).then(d => {
                            loaded.set(date, d);
                            this.loadedEmployeeListData$.next(loaded);
                            this.WorkDayLoading = false;
                            this.cd.detectChanges();
                        });
                    } else {
                        this.WorkDayLoading = false;
                        this.cd.detectChanges();
                    }
                });
            } else {
                this.loadedDayData$.pipe(take(1)).subscribe(loaded => {
                    if (!loaded.has(date)) {
                        this.loadDayList(moment(date, 'DD.MM.YYYY').toDate()).then(d => {
                            loaded.set(date, d);
                            this.loadedDayData$.next(loaded);
                            this.WorkDayLoading = false;
                            this.cd.detectChanges();
                        });
                    } else {
                        this.WorkDayLoading = false;
                        this.cd.detectChanges();
                    }
                });
            }
        }
    }

    timeSelectNext() {
        this.timeSelectOptions$.pipe(take(1)).subscribe(options => {
            let i = options.indexOf(this.timeSelect.value);
            i--;
            if (i >= 0) {
                this.timeSelect.setValue(options[i]);
            }
        });
    }

    timeSelectPrev() {
        this.timeSelectOptions$.pipe(take(1)).subscribe(options => {
            let i = options.indexOf(this.timeSelect.value);
            i++;
            if (i < options.length) {
                this.timeSelect.setValue(options[i]);
            }
        });
    }

    protected formatDayData(input: ClockInEntity[], commissions: CommissionEntity[], customerDictionary: Dictionary<CustomerEntity>, globalTypeId: number, clockInTypes: Dictionary<ClockInTypeEntity>): ClockInTableData[] {
        return input.sort(sortClockIns(globalTypeId)).map(d => {
            const commission = commissions.find((commission) => commission.Id === d.CommissionId);
            const customer = commission?.CustomerId ? customerDictionary[commission.CustomerId] : null;
            const forcedBreakTime = isNotNullOrUndefined(d.ForcedBreakTime) ? this.GetHourStringFromMilliseconds(d.ForcedBreakTime) : null;
            const note =
                isNotNullOrUndefined(d.ForcedBreakTime) && d.Type == this.ClockInTypes.Start && d.ForcedBreakTime > 0
                    ? (isNotNullOrUndefined(d.WorkDescription) ? d.WorkDescription + '\n\n' : '') + '*Es wurde eine Pausenzeit von ' + forcedBreakTime + ' automatisch abgezogen'
                    : d.WorkDescription;

            return {
                ClockInEntity: d,
                Type: clockInTypes[d.ClockInTypeId]?.Name + (d.ClockInTypeId === this.GlobalClockInTypeId ? '' : ' - ' + ClockInTypeNames.get(d.Type)),
                TimeStamp: moment(d.TimeStamp).format('HH:mm:ss'),
                Commission: commission?.DisplayName,
                Customer: customer ? customer.Name : null,
                Note: note,
                DrivingTime: null,
                CanEdit$: this.store.select(getEmployeeById({ id: d.EmployeeId })).pipe(map(e => e?.PermissionsFromEntityRoles.includes(Permissions.EditClockIn))),
            };
        });
    }

    protected loadDayList(date: Date): Promise<ClockInTableData[]> {
        let dateStr = moment(date).format('YYYY-MM-DD');
        let employeeId: number | null = null;
        let commissionId: number | null = null;
        return new Promise(resolve => {
            this.filterValues$.pipe(
                withLatestFrom(this.accessibleEmployeeIds$),
                take(1)
            ).subscribe(([filter, accessibleEmployeeIds]) => {
                let filterCommissionIds = filter[FilterTypes.Commissions].map(c => c.id);
                let filterEmployeeIds = filter[FilterTypes.Employees].map(e => e.id);

                if (!this.ignoreSeePermissions) {
                    if (filterEmployeeIds.length == 0) {
                        filterEmployeeIds = accessibleEmployeeIds;
                    } else {
                        filterEmployeeIds = filterEmployeeIds.filter(e => accessibleEmployeeIds.includes(e));
                    }
                }

                if (filterCommissionIds.length == 1) {
                    commissionId = filterCommissionIds[0];
                }
                if (filterEmployeeIds.length == 1) {
                    employeeId = filterEmployeeIds[0];
                }
                this.clockInDataService.get$({
                    workDayDate: moment(date).toISOString(),
                    employeeId: employeeId,
                    commissionId: commissionId,
                }).pipe(
                    map(data => data.filter(d => {
                        if (filterEmployeeIds.length != 0) {
                            if (!filterEmployeeIds.includes(d.EmployeeId)) {
                                return false;
                            }
                        }
                        if (filterCommissionIds.length != 0) {
                            if (!filterCommissionIds.includes(d.CommissionId)) {
                                return false;
                            }
                        }
                        return true;
                    })),
                    take(1),
                    switchMap(data =>
                        combineLatest([
                            of(data),
                            this.store.select(getCommissions),
                        ])
                    ),
                    switchMap(([data, commissions]) =>
                        combineLatest([
                            of(data),
                            this.store.select(getClockInTypes),
                            this.store.select(getClockInTypeDictionary),
                            this.customerDataService.GetCustomersDict$(
                                data
                                    .map(d => commissions.find(c => c.Id === d.CommissionId))
                                    .filter(isNotNullOrUndefined)
                                    .map(c => c.CustomerId)
                                    .filter(isNotNullOrUndefined),
                                true
                            ),
                            of(commissions)
                        ])
                    )
                ).subscribe(([data, clockInTypes, clockInTypesDict,customerDictionary, commissions]) => {
                    let globalTypeId = clockInTypes.find((ci) => ci.Slug === EnumClockInTypeSlug.workTime)?.Id;

                    let out = this.formatDayData(data, commissions, customerDictionary, globalTypeId, clockInTypesDict);
                    resolve(out);
                });

            });
        });

    }

    protected loadEmployeeList(date: Date): Promise<EmployeeListTableData[]> {
        let dateStr = moment(date).format('YYYY-MM-DD');
        let employeeId: number | null = null;
        let commissionId: number | null = null;
        return new Promise(resolve => {
            this.filterValues$.pipe(
                withLatestFrom(this.accessibleEmployeeIds$),
                take(1)
            ).subscribe(([filter, accessibleEmployeeIds]) => {
                let filterCommissionIds = filter[FilterTypes.Commissions].map(c => c.id);
                let filterEmployeeIds = filter[FilterTypes.Employees].map(e => e.id);

                if (!this.ignoreSeePermissions) {
                    if (filterEmployeeIds.length == 0) {
                        filterEmployeeIds = accessibleEmployeeIds;
                    } else {
                        filterEmployeeIds = filterEmployeeIds.filter(e => accessibleEmployeeIds.includes(e));
                    }
                }

                if (filterCommissionIds.length == 1) {
                    commissionId = filterCommissionIds[0];
                }
                if (filterEmployeeIds.length == 1) {
                    employeeId = filterEmployeeIds[0];
                }
                this.clockInDataService.get$({
                    workDayDate: moment(date).toISOString(),
                    employeeId: employeeId,
                    commissionId: commissionId,
                }).pipe(
                    map(data => data.filter(d => {
                        if (filterEmployeeIds.length != 0) {
                            if (!filterEmployeeIds.includes(d.EmployeeId)) {
                                return false;
                            }
                        }
                        if (filterCommissionIds.length != 0) {
                            if (!filterCommissionIds.includes(d.CommissionId)) {
                                return false;
                            }
                        }
                        return true;
                    })),
                    take(1),
                    switchMap(data =>
                        combineLatest([
                            of(data),
                            this.store.select(getCommissions),
                        ])
                    ),
                    switchMap(([data, commissions]) =>
                        combineLatest([
                            of(data),
                                this.store.select(getEmployeeDictionary),
                                this.store.select(getWorkDays),
                                this.store.select(getWorkedTimes),
                                this.store.select(getClockInTypes),
                                this.store.select(getClockInTypeDictionary),
                                this.customerDataService.GetCustomersDict$(
                                    data
                                        .map(d => commissions.find(c => c.Id === d.CommissionId))
                                        .filter(isNotNullOrUndefined)
                                        .map(c => c.CustomerId)
                                        .filter(isNotNullOrUndefined),
                                    true
                                ),
                                of(commissions)
                        ])
                    )
                ).subscribe(([data, employeeMap, workDays, workedTimes, clockInTypes, clockInTypeDict, customerDictionary, commissions]) => {
                    let drivingTimeId = clockInTypes.find((ci) => ci.Slug === EnumClockInTypeSlug.drivingTime)?.Id;
                    let commissionTimeId = clockInTypes.find((ci) => ci.Slug === EnumClockInTypeSlug.commissionWorkTime)?.Id;
                    let globalTypeId = clockInTypes.find((ci) => ci.Slug === EnumClockInTypeSlug.workTime)?.Id;

                    let employeeMapTmp = new Map<number, ClockInEntity[]>();
                    data.forEach(d => {
                        if (d.EmployeeId) {
                            if (!employeeMapTmp.has(d.EmployeeId)) {
                                employeeMapTmp.set(d.EmployeeId, []);
                            }
                            employeeMapTmp.get(d.EmployeeId).push(d);
                        }
                    });
                    let out: EmployeeListTableData[] = [];
                    employeeMapTmp.forEach((d, eId) => {
                        let e = employeeMap[eId];
                        let wds = workDays.filter(d => d.EmployeeId == eId && moment(d.Timestamp).format('YYYY-MM-DD') == dateStr);
                        let wd : WorkDayEntity;
                        if (wds.length != 0) {
                            wd = wds[0];
                        }else{
                            wd = undefined
                        }

                        let workedTimesDay = workedTimes.filter(wt => wt.WorkDayId == wd?.Id);

                        if (filterCommissionIds.length != 0) {
                            workedTimesDay = workedTimesDay.filter(wt => filterCommissionIds.includes(wt.CommissionId));
                        }

                        let drivingWt = workedTimesDay.filter(d => d.ClockInTypeId == drivingTimeId);
                        let projectWt = workedTimesDay.filter(d => d.ClockInTypeId == commissionTimeId);

                        out.push({
                            Date: date,
                            DisplayName: e.DisplayName,
                            ClockInTableData: new MatTableDataSource(this.formatDayData(d, commissions, customerDictionary, globalTypeId, clockInTypeDict)),
                            DrivingTime: this.GetHourStringFromMilliseconds(drivingWt.map(d => d.Timespan).reduce((a, b) => a + b, 0)),
                            EmployeeId: eId,
                            WorkDayId: wd.Id,
                            WorkTime: this.GetHourStringFromMilliseconds(wd.Timespan),
                            Identifier: moment(wd.Timestamp).format('dd.MM.yyyy') + '-index' + eId,
                            IsValid: !wds.find(d => !d.IsValid),
                            OtherClockInsExist: d.length > 1,
                            ProjectTime: this.GetHourStringFromMilliseconds(projectWt.map(d => d.Timespan).reduce((a, b) => a + b, 0)),
                        });
                    });
                    resolve(out);
                });
            });
        });
    }

    private pad(num, size) {
        let s = '000000000' + num;
        return s.substr(s.length - size);
    }

    private fetchData(year: number, quarter: number | null, employeeIds: number[], commissionIds: number[]) {
        this.mainDataLoaded = false;
        this.accessibleEmployeeIds$.pipe(
            take(1),
        ).subscribe(accessibleIds => {
            if (!this.ignoreSeePermissions) {
                if (employeeIds.length == 0) {
                    employeeIds = accessibleIds;
                } else {
                    employeeIds = employeeIds.filter(e => accessibleIds.includes(e));
                }
            }
            if (employeeIds.length == 1) {
                this.showEmployeeHierarchie = false
            }
            this.clockInDataService.GetHourListData(year, quarter, commissionIds, employeeIds).then((data) => {
                if (data.data.length === 0) {
                    this.PanelData = [];
                    this.mainDataLoaded = true;
                    let timeSelectOptions: string[] = [];
                    let fromDate = moment(data.from);
                    let toDate = moment(data.to);
                    this.fromDataDate$.next(fromDate.format('DD.MM.YYYY'));
                    this.toDataDate$.next(toDate.format('DD.MM.YYYY'));

                    if (quarter === null) {
                        fromDate = fromDate.startOf('year');
                        while (fromDate.isBefore(toDate)) {
                            timeSelectOptions.push(fromDate.format('YYYY'));
                            fromDate = fromDate.add(1, 'year');
                        }
                    } else {
                        fromDate = fromDate.startOf('quarter');
                        while (fromDate.isBefore(toDate)) {
                            timeSelectOptions.push(fromDate.format('YYYY.Q'));
                            fromDate = fromDate.add(1, 'quarter');
                        }
                    }
                    timeSelectOptions.sort((a, b) => b.localeCompare(a));
                    if (!timeSelectOptions.includes(this.timeSelect.value)) {
                        console.log('!timeSelectOptions.includ');
                        this.timeSelect.setValue(timeSelectOptions[0]);
                    }
                    this.timeSelectOptions$.next(timeSelectOptions);
                    return;
                }
                combineLatest([
                    this.store.select(getCommissionDictionary),
                    this.customerDataService.GetCustomersDict$(
                        data.data
                            .map(d => d.CustomerIds)
                            .flat(),
                        true
                    ),
                    this.store.select(getEmployeeToVacationDictionary)
                ]).pipe(
                    take(1)
                ).subscribe(([commissionsDictionary, customerDictionary, employeeToVacationDictionary]) => {
                    let kwMap = new Map<
                        string,
                        {
                            days: WorkDayTableData[];
                            from: Date;
                            to: Date;
                        }
                    >();
                    let timeSelectOptions: string[] = [];
                    let fromDate = moment(data.from);
                    let toDate = moment(data.to);
                    // fromDate = moment("01.01.2023", "DD.MM.YYYY");
                    // toDate = moment("01.02.2026", "DD.MM.YYYY");
                    this.fromDataDate$.next(fromDate.format('DD.MM.YYYY'));
                    this.toDataDate$.next(toDate.format('DD.MM.YYYY'));

                    if (quarter === null) {
                        fromDate = fromDate.startOf('year');
                        while (fromDate.isBefore(toDate)) {
                            timeSelectOptions.push(fromDate.format('YYYY'));
                            fromDate = fromDate.add(1, 'year');
                        }
                    } else {
                        fromDate = fromDate.startOf('quarter');
                        while (fromDate.isBefore(toDate)) {
                            timeSelectOptions.push(fromDate.format('YYYY.Q'));
                            fromDate = fromDate.add(1, 'quarter');
                        }
                    }
                    timeSelectOptions.sort((a, b) => b.localeCompare(a));
                    if (!timeSelectOptions.includes(this.timeSelect.value)) {
                        console.log('!timeSelectOptions.includ');
                        this.timeSelect.setValue(timeSelectOptions[0]);
                    }
                    this.timeSelectOptions$.next(timeSelectOptions);

                    data.data.forEach((dayData) => {
                        let year = moment(dayData.Date).year();
                        let week = moment(dayData.Date).isoWeek();
                        let key = year + '-' + week;
                        let kwData = {
                            days: [],
                            to: moment()
                                .year(year + 1)
                                .toDate(),
                            from: moment().year(year).startOf('year').toDate(),
                        };
                        if (kwMap.has(key)) {
                            kwData = kwMap.get(key);
                        }
                        let loading = new BehaviorSubject(false);
                        let isValid$ :BehaviorSubject<boolean> = new BehaviorSubject(true);


                        if(employeeIds.length != 0 && dayData.HasInvalid){
                            isValid$.next(false);
                        }
                        //ToDo mit Ticket D277-5740 wieder werte vom BE nehmen

                        kwData.days.push({
                            Date: moment(dayData.Date).format('DD.MM.YYYY'),
                            TableData$: this.loadedDayData$.pipe(
                                filter(loaded => loaded.has(moment(dayData.Date).format('DD.MM.YYYY'))),
                                map(loaded => loaded.get(moment(dayData.Date).format('DD.MM.YYYY'))),
                            ),
                            BreakTime: dayData.BreakTime,
                            CanDeleteAll: dayData.CanDeleteAll,
                            ShowDeleteAll: dayData.WorkdayIds.length < 2,
                            DrivingTime: dayData.DrivingTime,
                            CommissionNames: dayData.CommissionIds.map((cId) => (commissionsDictionary[cId] ? commissionsDictionary[cId].Auftragsnummer || 'unbenannt' : 'unbekannt')).join(', '),
                            EmployeeListData$: this.loadedEmployeeListData$.pipe(
                                filter(loaded => loaded.has(moment(dayData.Date).format('DD.MM.YYYY'))),
                                map(loaded => loaded.get(moment(dayData.Date).format('DD.MM.YYYY')))
                            ),
                            ForcedBreakTime: dayData.ForcedBreakTime,
                            ProjectTime: dayData.ProjectTime,
                            WorkTime: dayData.WorkTime,
                            OverTime: dayData.OverTime,
                            IsLoading$: loading,
                            DateData: dayData.Date,
                            CustomerNames: dayData.CustomerIds.map((cId) => (customerDictionary[cId] ? customerDictionary[cId].Name || 'unbenannt' : 'unbekannt')).join(', '),
                            EmployeeToVacations: dayData.EmployeeToVacationsIds.map((eId) => (employeeToVacationDictionary[eId])),
                            EveryValid$: isValid$,
                            WorkdayIds: dayData.WorkdayIds,
                            IsHoliday: dayData.IsHoliday,
                            SalaryTypes$: this.ShowEmployeeSalaryTypesForEmployeeId$.pipe(
                                switchMap(employeeId => employeeId ? this.store.select(getEmployeeSalaryTypes).pipe(map((salarys) =>
                                    salarys.filter(s => s.EmployeeId === employeeId && sameDay(s.Date, dayData.Date))
                                        .map((salaryType) => {
                                            return {
                                                salaryType,
                                                commissionLabel$: salaryType.CommissionId && this.store.select(getCommissionById({ id: salaryType.CommissionId })).pipe(map((c) => c?.DisplayName)),
                                            };
                                        }),
                                )) : of(null)),
                            ),
                            SomeExported: dayData.SomeExported,
                        } as WorkDayTableData);
                        if (kwData.from.getTime() < dayData.Date.getTime()) {
                            kwData.from = dayData.Date;
                        }
                        if (kwData.to.getTime() > dayData.Date.getTime()) {
                            kwData.to = dayData.Date;
                        }

                        kwMap.set(key, kwData);
                    });

                    let out: PanelData[] = [];
                    kwMap.forEach((data, yearWeek) => {
                        let end = moment(data.to).endOf('isoWeek');
                        let sort = end.year() + '-' + this.pad(moment(data.to).week(), 2);
                        out.push({
                            Sort: sort,
                            Year: moment(data.to).year(),
                            WeekOfYear: moment(data.to).isoWeek(),
                            OverTimeSum: data.days.reduce((pv, d) => pv + d.OverTime, 0),
                            ProjectTimeSum: data.days.reduce((pv, d) => pv + d.ProjectTime, 0),
                            WeekEnd: moment(data.to).endOf('isoWeek').format('DD.MM.YYYY'),
                            WeekStart: moment(data.from).startOf('isoWeek').format('DD.MM.YYYY'),
                            WorkTimeSum: data.days.reduce((pv, d) => pv + d.WorkTime, 0),
                            TableData: new MatTableDataSource(data.days.reverse()),
                        });
                    });

                    out.sort((a, b) => a.Sort.localeCompare(b.Sort)).reverse();

                    this.PanelData = out;
                    this.mainDataLoaded = true;
                    // this.cd.markForCheck();
                });

            });
        });
    }

    protected subscriptions: Subscription[] = [];

    doReload(timespan: {
        Year: number,
        Quarter: number
    }, filterValues: HourListFilter) {
        this.loadedDayData$.next(new Map<string, ClockInTableData[]>());
        this.loadedEmployeeListData$.next(new Map<string, EmployeeListTableData[]>());
        this.fetchData(timespan.Year, timespan.Quarter, filterValues.employees.map(e => e.id), filterValues.commissions.map(e => e.id));
        if (isNotNullOrUndefined(this.ExpandedWorkDay)) {
            console.log('doreload ExpandedWorkDay', this.ExpandedWorkDay);
            this.toggleDay(this.ExpandedWorkDay, true);
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    ngOnInit() {
        this.onInit$.next(true);


        this.subscriptions.push(
            combineLatest([
                this.timeSelect.valueChanges.pipe(
                    startWith(null),
                    map(() => {
                        return getTimespanObjectFromTimeSelectString(this.timeSelect.value);
                    }),
                ),
                this.filterValues$,
            ])
                .subscribe(([timespan, filterValues]) => {
               this.fetchData(timespan.Year, timespan.Quarter, filterValues.employees.map(e => e.id), filterValues.commissions.map(e => e.id));
            }),
            this.yearQuarter.valueChanges.subscribe(yq => {
                let v = this.timeSelect.value;
                console.log('this.yearQuarter.valueChanges.subscrib');
                if (yq == YearQuarter.Year) {
                    this.timeSelect.setValue(v.split('.')[0]);
                } else {
                    this.timeSelect.setValue(v + '.1');
                }
            }),
        );
    }

    public EditingClockIn(clockInEntity: ClockInEntity) {
        this.dialog.open<NewClockinPopupComponent, NewClockinPopupComponentDialogData>(NewClockinPopupComponent, {
            ...NewClockinPopupComponent.DefaultConfig,
            data: {
                New: false,
                ClockInEntity: clockInEntity,
                SelectDate: true,
                SelectDateEnd: false,
                Close: true,
                EmployeeId: clockInEntity.EmployeeId,
            },
        });
    }

    CreateEmployeeSalaryType(employeeId?: number, date?: Date) {
        this.openEmployeeSalaryDialog(null, employeeId, date);
    }

    ChangeEmployeeSalaryType(id: number) {
        this.openEmployeeSalaryDialog(id);
    }

    async openEmployeeSalaryDialog(id?: number, employeeId?: number, date?: Date) {
        let employeeSalaryType: EmployeeSalaryTypeEntity | undefined;
        if (id) {
            employeeSalaryType = await firstValueFrom(this.store.select(getEmployeeSalaryTypeById({ id })));
            if (!employeeSalaryType) {
                throw Error('employeeSalaryType ' + id + ' not found');
            }
        }
        firstValueFrom(this.store.select(getSalaryTypeFetched)).then((fetched) => {
            if (!fetched) {
                this.salaryTypeResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getTravelZonesFetched)).then((fetched) => {
            if (!fetched) {
                this.travelZoneResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getCommissionsFetched)).then((fetched) => {
            if (!fetched) {
                this.commissionResolver.resolve();
            }
        });
        firstValueFrom(this.store.select(getStatusFromBackofficeFetched)).then((fetched) => {
            if (!fetched) {
                this.statusBackofficeResolver.resolve();
            }
        });
        const commissionLabel = await firstValueFrom(this.cls.getSingle$('Commission'));
        const commission = employeeSalaryType?.CommissionId
            ? await firstValueFrom(
                this.store.select(getCommissionsFetched).pipe(
                    filter((f) => f),
                    switchMap(() => this.store.select(getCommissionById({ id: employeeSalaryType.CommissionId }))),
                ),
            )
            : null;
        let optionLableSalaryType = '';
        getFetched$(this.store, getSalaryTypeFetched, getEmployeeSalaryTypeById({ id: employeeSalaryType?.SalaryTypeId }))
            .pipe(take(1))
            .subscribe((val) => (optionLableSalaryType = val?.Name || null));
        const form = new FormGroup({
            name: new FormControl<string>(employeeSalaryType?.Name || null, [Validators.required]),
            date: new FormControl<Moment>(moment(date || employeeSalaryType?.Date || null), [Validators.required]),
            salaryType: new FormControl<{ Id: number }>(null),
            salaryTypeNumber: new FormControl<number>(employeeSalaryType?.SalaryTypeNumber || null, [Validators.required]),
            bs: new FormControl<number>(employeeSalaryType?.Bearbeitungsschluessel || null),
            amount: new FormControl<number>(employeeSalaryType?.Amount / 100 || null),
            percentAmount: new FormControl<number>(employeeSalaryType?.PercentAmountFromSalary || null),
            description: new FormControl<string>(employeeSalaryType?.Description || null),
            commission: new FormControl<CommissionEntity>(commission),
            travelZoneId: new FormControl<number>(employeeSalaryType?.TravelZoneId || null),
            salaryTypeId: new FormControl<{
                Id: number;
                optionLable: string
            } | null>(employeeSalaryType?.SalaryTypeId ? {
                Id: employeeSalaryType?.SalaryTypeId,
                optionLable: optionLableSalaryType,
            } : null),
        });
        const valueChangeSubs = [
            form.controls.travelZoneId.valueChanges.subscribe((tz) => {
                this.store
                    .select(getTravelZoneById({ id: tz }))
                    .pipe(take(1))
                    .subscribe((tz) => {
                        form.patchValue({
                            name: tz.Name,
                            salaryTypeNumber: tz.TravelZoneNumber,
                            bs: tz.Bearbeitungsschluessel,
                            amount: tz.Amount / 100,
                            percentAmount: tz.PercentAmountFromTravelZone,
                            description: tz.Description,
                        });
                    });
            }),
            form.controls.salaryTypeId.valueChanges.subscribe((st) => {
                this.store
                    .select(getSalaryTypeById({ id: st.Id }))
                    .pipe(take(1))
                    .subscribe((st) => {
                        form.patchValue({
                            name: st.Name,
                            salaryTypeNumber: st.SalaryTypeNumber,
                            bs: st.Bearbeitungsschluessel,
                            amount: st.Amount / 100,
                            percentAmount: st.PercentAmountFromSalary,
                            description: st.Description,
                        });
                    });
            }),
        ];

        if (employeeSalaryType?.CommissionId && !commission) {
            // maybe commission is not available for this user
            form.controls.commission.disable();
        }
        const dialogRef = this.dialog.open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
            ...DetailListTemplateDialogComponent.DefaultConfig,
            data: {
                DisableSaveButton$: form.statusChanges.pipe(
                    startWith(form.status),
                    map((state) => state !== 'VALID'),
                ),
                Data: {
                    HeaderIcon: this.EmployeeSalaryTypeIcon,
                    Headline: this.EmployeeSalaryTypeLabel,
                    Properties: [
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('Date'),
                            formControl: form.controls.date,
                            options: {
                                specialInput: {
                                    date: true,
                                },
                            },
                        },
                        {
                            key: commissionLabel,
                            formControl: form.controls.commission,
                            options: {
                                specialInput: {
                                    singleSelectSearch: {
                                        options$: this.store.select(getCommissionsActive).pipe(
                                            filter(isNotNullOrUndefined),
                                            map((commissions) => [commission, ...commissions.filter((c) => c.Id !== commission?.Id)].filter(isNotNullOrUndefined)),
                                        ),
                                        compareOptions: (a, b) => a?.Id === b?.Id,
                                    },
                                },
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('TravelZoneId'),
                            formControl: form.controls.travelZoneId,
                            options: {
                                specialInput: { travelZoneId: { requiredId: form.controls.travelZoneId.value } },
                            },
                        },
                        {
                            key: SalaryTypeEntity.EntityName,
                            formControl: form.controls.salaryTypeId,
                            options: {
                                specialInput: {
                                    customTemplate: this.selectSalaryTypeForm,
                                },
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('Name'),
                            formControl: form.controls.name,
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('SalaryTypeNumber'),
                            formControl: form.controls.salaryTypeNumber,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('Bearbeitungsschluessel'),
                            formControl: form.controls.bs,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('Amount'),
                            formControl: form.controls.amount,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('PercentAmountFromSalary'),
                            formControl: form.controls.percentAmount,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                                suffix: '%',
                                showHint: 'Dieser prozentuale Wert wird dem errechneten Tageslohn aus Stunden und Stundenlohn in der Export Datei hinzugefügt',
                            },
                        },
                        {
                            key: EmployeeSalaryTypeEntity.EntityPropertyNames.get('Description'),
                            formControl: form.controls.description,
                            options: {
                                specialInput: {
                                    textArea: {
                                        Fill: true,
                                    },
                                },
                            },
                        },
                    ],
                },
                Editing: true,
                DeleteButton: !!id,
            },
        });

        this.actions$
            .pipe(
                takeUntil(dialogRef.beforeClosed()),
                ofType(SalaryTypeActions.add),
                switchMap(() => this.actions$.pipe(ofType(SalaryTypeActions.updateOne, BaseActionTypes.ErrorAction), first())),
            )
            .subscribe((action) => {
                if (action.type === SalaryTypeActions.updateOne.type) {
                    form.controls.salaryType.setValue({ Id: action.Payload.Id });
                }
            });
        form.controls.commission.valueChanges
            .pipe(
                takeUntil(dialogRef.beforeClosed()),
            )
            .subscribe((commission) => {
                if (commission?.TravelZoneId) {
                    form.controls.travelZoneId.setValue(commission.TravelZoneId);
                    form.controls.travelZoneId.markAsDirty();
                }
            });
        form.controls.salaryType.valueChanges.pipe(takeUntil(dialogRef.beforeClosed()), withLatestFrom(this.store.select(getSalaryTypeDictionary))).subscribe(([value, salaryTypes]) => {
            if (value) {
                const type = salaryTypes[value.Id];
                if (type) {
                    form.patchValue({
                        name: type.Name,
                        salaryType: value,
                        salaryTypeNumber: type.SalaryTypeNumber,
                        bs: type.Bearbeitungsschluessel,
                        amount: type.Amount,
                        percentAmount: type.PercentAmountFromSalary,
                        description: type.Description,
                    });
                }
            }
        });
        dialogRef.afterClosed().subscribe((res) => {
            valueChangeSubs.forEach((subs) => subs.unsubscribe());
            if (res?.Action === 'delete') {
                this.store.dispatch(EmployeeSalaryTypeActions.delete({ Payload: { id } }));
            } else if (res?.Action === 'save') {
                if (id) {
                    this.store.dispatch(
                        EmployeeSalaryTypeActions.change({
                            Payload: {
                                id,
                                name: form.value.name,
                                amount: form.value.amount * 100,
                                bearbeitungsschluessel: form.value.bs,
                                commissionId: form.controls.commission.getRawValue()?.Id || null,
                                date: FrontendDate(form.value.date.toDate()),
                                description: form.value.description,
                                percentAmountFromSalary: form.value.percentAmount,
                                salaryTypeNumber: form.value.salaryTypeNumber,
                                travelZoneId: form.value.travelZoneId,
                                salaryTypeId: form.value.salaryTypeId?.Id,
                            },
                        }),
                    );
                } else {
                    this.store.dispatch(
                        EmployeeSalaryTypeActions.add({
                            Payload: {
                                name: form.value.name,
                                amount: form.value.amount * 100,
                                bearbeitungsschluessel: form.value.bs,
                                commissionId: form.controls.commission.getRawValue()?.Id || null,
                                employeeId,
                                date: FrontendDate(form.value.date.toDate()),
                                description: form.value.description,
                                percentAmountFromSalary: form.value.percentAmount,
                                salaryTypeNumber: form.value.salaryTypeNumber,
                                travelZoneId: form.value.travelZoneId,
                                salaryTypeId: form.value.salaryTypeId?.Id,
                            },
                        }),
                    );
                }
            }
        });
    }

    onAddSalaryTypeClick() {
        const form = new FormGroup({
            name: new FormControl<string>(null, [Validators.required]),
            salaryTypeNumber: new FormControl<number>(null, [Validators.required]),
            bs: new FormControl<number>(null),
            amount: new FormControl<number>(null),
            percentAmount: new FormControl<number>(null),
            description: new FormControl<string>(null),
        });
        const dialogRef = this.dialog.open<DetailListTemplateDialogComponent, DetailListTemplateDialogData, DetailListDialogReturn>(DetailListTemplateDialogComponent, {
            ...DetailListTemplateDialogComponent.DefaultConfig,
            data: {
                DisableSaveButton$: form.statusChanges.pipe(
                    startWith(form.status),
                    map((state) => state !== 'VALID'),
                ),
                Data: {
                    HeaderIcon: this.EmployeeSalaryTypeIcon,
                    Headline: 'Lohnart anlegen',
                    Properties: [
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('Name'),
                            formControl: form.controls.name,
                        },
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('SalaryTypeNumber'),
                            formControl: form.controls.salaryTypeNumber,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('Bearbeitungsschluessel'),
                            formControl: form.controls.bs,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('Amount'),
                            formControl: form.controls.amount,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('PercentAmountFromSalary'),
                            formControl: form.controls.percentAmount,
                            options: {
                                specialInput: {
                                    number: true,
                                },
                            },
                        },
                        {
                            key: SalaryTypeEntity.EntityPropertyNames.get('Description'),
                            formControl: form.controls.description,
                            options: {
                                specialInput: {
                                    textArea: {
                                        Fill: true,
                                    },
                                },
                            },
                        },
                    ],
                },
                Editing: true,
            },
        });

        dialogRef.afterClosed().subscribe((res) => {
            if (res?.Action === 'save') {
                this.store.dispatch(
                    SalaryTypeActions.add({
                        Payload: {
                            name: form.value.name,
                            amount: form.value.amount * 100,
                            bearbeitungsschluessel: form.value.bs,
                            description: form.value.description,
                            percentAmountFromSalary: form.value.percentAmount,
                            salaryTypeNumber: form.value.salaryTypeNumber,
                        },
                    }),
                );
            }
        });
    }

    CreateClockIn(employeeId?: number, date?: Date) {
        firstValueFrom(combineLatest([this.filteredCommissionIds$, this.filteredEmployeeIds$])).then(([commissionIds, employeeIds]) => {
            if (employeeId || employeeIds?.length === 1) {
                this.dialog.open<NewClockinPopupComponent, NewClockinPopupComponentDialogData>(NewClockinPopupComponent, {
                    ...NewClockinPopupComponent.DefaultConfig,
                    data: {
                        EmployeeId: employeeId || employeeIds[0],
                        Date: date,
                        New: true,
                        SelectDate: true,
                        SelectDateEnd: true,
                        Close: true,
                        CommissionId: commissionIds?.length === 1 ? commissionIds[0] : null,
                        UsersOfCommission: [],
                    },
                });
            } else if (commissionIds?.length === 1) {
                combineLatest([
                    this.store.select(getUser),
                    this.store.select(getEmployees),
                    this.store.select(getUserDictionary),
                    this.store.select(getCommissionById({ id: commissionIds[0] })),
                    getFetched$(this.store, getUserToCommissionFetched, getUserToCommissionByCommissionId({ commissionId: commissionIds[0] })),
                ])
                    .pipe(take(1))
                    .subscribe(([user, employees, users, commission, userToCommissions]) => {
                        const userIds = uniqArray(userToCommissions.map((u2c) => u2c?.UserId).filter(isNotNullOrUndefined));
                        const availableEmployees = employees.filter((e) => e.UserId && userIds.includes(e.UserId) && e.EmployeeStatus === EmployeeStatusEnum.Aktiv);
                        this.dialog.open<NewClockinPopupComponent, NewClockinPopupComponentDialogData>(NewClockinPopupComponent, {
                            ...NewClockinPopupComponent.DefaultConfig,
                            data: {
                                EmployeeId: employees.find((e) => e.UserId === user.Id).Id,
                                Date: date,
                                New: true,
                                SelectDate: true,
                                SelectDateEnd: true,
                                Close: true,
                                CommissionId: commission.Id,
                                ShowEmployeeList: true,
                                UsersOfCommission: availableEmployees.map((e) => users[e.UserId]).filter(isNotNullOrUndefined),
                            },
                        });
                    });
            } else {
                combineLatest([this.store.select(getUser), this.store.select(getEmployees), this.store.select(getUserDictionary)])
                    .pipe(take(1))
                    .subscribe(([user, employees, users]) => {
                        const availableEmployees = employees.filter((e) => e.UserId && e.EmployeeStatus === EmployeeStatusEnum.Aktiv);

                        this.dialog.open<NewClockinPopupComponent, NewClockinPopupComponentDialogData>(NewClockinPopupComponent, {
                            ...NewClockinPopupComponent.DefaultConfig,
                            data: {
                                EmployeeId: employees.find((e) => e.UserId === user.Id).Id,
                                Date: date,
                                New: true,
                                SelectDate: true,
                                SelectDateEnd: true,
                                ShowEmployeeList: true,
                                UsersOfCommission: availableEmployees.map((e) => users[e.UserId]).filter(isNotNullOrUndefined),
                                Close: true,
                            },
                        });
                    });
            }
        });
    }

    GetHourStringFromMilliseconds(ms: number): string {
        if (!ms) {
            return '';
        }
        const neg = ms < 0;
        const mSeconds = neg ? ms * -1 : ms;
        const hours = Math.trunc(mSeconds / (1000 * 60 * 60));
        const minutes = Math.round((mSeconds / (1000 * 60 * 60) - hours) * 60);
        return (neg ? '- ' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + 'h';
    }

    DeleteWorkDay(day: Date, event: MouseEvent) {
        event.stopPropagation();
        const dialogRef = this.dialog.open<AppConfirmationDialogComponent, AppConfirmationDialogData, [boolean, string]>(AppConfirmationDialogComponent, {
            autoFocus: false,
            data: {
                paragraph: `Wollen Sie die Arbeitszeiten wirklich löschen?`,
                styleDelete: true,
            },
            maxWidth: '400px',
            width: '90%',
            // disableClose: true,
        }).afterClosed().subscribe((res) => {
            // const clockinsToDelete = clockIns.filter((c) => c.WorkDayId === workDayId);
            if (res && res[0]) {
                const clockInsToDelete = this.loadedDayData$.value.get(moment(day).format('DD.MM.YYYY'));
                if (clockInsToDelete.length) {
                    this.clockInHelperService.dispatchClockInActions([], [], clockInsToDelete.map(c => ({ id: c.ClockInEntity.Id })));
                }
            }
        });
    }

    protected readonly VacationTypeEnumNameMap = VacationTypeEnumNameMap;
    protected readonly EmployeeStatusEnum = EmployeeStatusEnum;

    public OpenCSVDialog() {
        this.dialog.open<CsvExportDialogComponent, CsvExportDialogComponentDialogData>(CsvExportDialogComponent, {
            ...CsvExportDialogComponent.DefaultConfig,
            data: {
                exportType: ClockInExportType.commission,
                selectedCommissionId: this.showCommissionCsvExportBtn,
            },
        });
    }





}
